








































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { AlbumManagementService as albumApi } from "@/common/api/services/AlbumManagementService";
import { PostGroupMangerService as postGroupApi } from "@/common/api/services/PostGroupMangerService";
import { namespace } from "vuex-class";
import { compareWithKeys } from "@/common/utils";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import moment from "moment";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import uploadImage from "@/components/common/uploadImage.vue";

const auth = namespace("Auth");

@Component({
  name: "AlbumEdit",
  components: {
    Multiselect,
    QCalendar,
    QErrors,
    uploadImage,
  },
})
export default class AlbumEdit extends Vue {
  @auth.Getter
  getUsingGroup!: number;
  @auth.Getter
  isPrivateUsingGroup: boolean;

  public dateConfig = {
    minDate: new Date(),
    dateFormat: "Y-m-d H:i",
    enableTime: true,
    minuteIncrement: 15,
    defaultHour: 0,
    defaultMinute: 0,
    allowInput: false,
  };

  public selectedGroups = [];

  public uploading = false;

  public albumId;

  public postGroups = [];

  public errors = {};
  public defaultAllGroup = { id: "all", name: "制限なし" };

  readonly RELEASE_NOW = "now";
  readonly RELEASE_DATE = "date";

  public form: any = {
    title: "",
    openSatatus: "editing",
    postDate: "",
    postGroups: [],
    files: [],
    id: null,
    createdAt: null,
    userCreated: null,
    releaseSetting: this.RELEASE_NOW,
  };

  public originalForm;

  public uploadOptions = {
    maxFilesize: 5, // 5mb
    acceptedFiles: ".jpg,.png,.jpeg",
  };

  public statusList = [
    { id: "editing", name: "編集中" },
    { id: "release", name: "公開中" },
    { id: "delete", name: "削除" },
  ];

  public title = "アルバムの新規作成";

  public includePostGroups: any = [];

  async mounted() {
    this.albumId = this.$router.currentRoute.params?.id;

    if (this.albumId) {
      await this.getDetail();
    } else {
      this.form.postGroups = this.selectedGroups = [this.defaultAllGroup];
    }
    this.originalForm = { ...this.form };

    if (this.form.releaseSetting == "") {
      this.form.releaseSetting = this.RELEASE_NOW;
    }

    await this.postGroup();

    window.onpopstate = (event) => {
      return this.$router.push({ name: "admin.album" });
    };
  }

  public async postGroup() {
    let result = await postGroupApi.postGroup({
      groupId: this.getUsingGroup,
      includes: this.includePostGroups,
    });
    this.postGroups = result.data.post_groups;
    if (this.postGroups.length > 0) {
      this.postGroups.unshift(this.defaultAllGroup);
    }
  }

  public async getDetail() {
    let result = await albumApi.groupAdminAlbumDetail({
      id: this.albumId,
      groupId: this.getUsingGroup,
    });

    this.form = result.data.album;
    this.form.postDate = moment(this.form.postDate).format("YYYY-MM-DD HH:mm");
    this.form.openSatatus =
      this.form.openSatatus === "wait" ? "release" : this.form.openSatatus;
    this.selectedGroups = this.form.postGroups;
    this.title = `${this.form.title} の編集`;
    if (
      this.form.openSatatus === "release" &&
      moment(this.form.postDate).isBefore(moment())
    ) {
      this.form.releaseSetting = this.RELEASE_NOW;
      this.form.postDate = null;
    }
    if (this.form.postGroups.length === 0) {
      this.form.postGroups = this.selectedGroups = [this.defaultAllGroup];
    }
    this.includePostGroups = this.form.postGroups.map(
      (post_group) => post_group.id
    );
  }

  public async submit() {
    let parameters = { ...this.form };

    parameters.attachFiles = [];
    parameters.groupId = this.getUsingGroup;

    if (parameters.releaseSetting == this.RELEASE_NOW) {
      parameters.postDate = moment().format("YYYY-MM-DD HH:mm:ss");
    }
    if (parameters.images && parameters.images.length > 0) {
      parameters.attachFiles = parameters.images.map((item) => {
        return item.id;
      });
      parameters.images = [];
    }

    parameters.postGroups = parameters.postGroups.map((item) => {
      return item.id;
    });
    let result;
    try {
      result = await albumApi.groupAdminAlbumEdit(parameters);
      qNotify.success({
        text: this.albumId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.$router.push({ name: "admin.album" });
    } catch (error: any) {
      result = error.body;
      qNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
    }
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(this.form, this.originalForm, [
      "images",
      "groupId",
      "id",
      "title",
      "openSatatus",
      "postDate",
      "postGroups",
      "release",
    ]);

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content", {
          name: this.form.name,
        })}`,
        // confirmText: `${this.$t("common.message.cancel_button")}`,
        onConfirm: () => {
          this.$router.push({ name: "admin.album" });
        },
      });
    } else {
      this.$router.push({ name: "admin.album" });
    }
  }

  public removeFile(file, index) {
    this.form.images.splice(index, 1);
  }

  public isStatusChecked(postGroup) {
    return this.form.postGroups.some((item) => item.id === postGroup.id);
  }

  public changeTypeRelease() {
    this.form = { ...this.form, releaseSetting: this.form.releaseSetting };

    if (this.form.releaseSetting == this.RELEASE_DATE) {
      const date = new Date();
      let minutes = date.getMinutes();
      let hours = date.getHours();
      let defaultMinute = "00";

      if (minutes > 0 && minutes <= 15) {
        defaultMinute = "15";
      } else if (minutes > 15 && minutes <= 30) {
        defaultMinute = "30";
      } else if (minutes > 30 && minutes <= 45) {
        defaultMinute = "45";
      } else if (minutes > 45) {
        hours++;
      }
      this.form.postDate = moment().format(
        "YYYY-MM-DD " + hours + ":" + defaultMinute
      );
    } else if (this.form.releaseSetting == this.RELEASE_NOW) {
      this.form.postDate = null;
    }
  }

  public changePostGroup() {
    if (this.selectedGroups.length === 0) {
      this.selectedGroups.push(this.defaultAllGroup);
    } else if (
      this.selectedGroups.some((item) => item.id === "all") &&
      this.selectedGroups.length > 1
    ) {
      this.selectedGroups = this.selectedGroups.filter((selectedGroup) => {
        return selectedGroup.id != "all";
      });
    }
    this.form.postGroups = this.selectedGroups;
  }

  public changeFile(files) {
    this.form.images = files;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }
}
